<template>
  <page pageName="about">
    <v-row class="px-0 pt-12">
      <v-col>
        <h1 class="center--text gm-darkblue--text">Projects</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="px-0 py-0">
        <div class="d-flex highlight-img"></div>
      </v-col>

      <!-- Desktop Grid -->
      <v-col cols="12" class="d-none d-md-flex">
        <v-row>
          <v-col v-for="(project, i) in projects" :key="i" cols="4" class="px-6">
            <v-card>
              <img :src="project.image" contain width="100%"/>

              <v-card-text>
                <div class="project-details">
                  <h3 class="project-name">{{project.name}}</h3>
                  <p class="project-location">Location: {{project.location}}</p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <!-- Tablet Grid -->
      <v-col cols="12" class="d-none d-sm-flex d-md-none">
        <v-row>
          <v-col v-for="(project, i) in projects" :key="i" cols="6" class="px-6">
            <v-card>
              <img :src="project.image" contain width="100%"/>

              <v-card-text>
                <div class="project-details">
                  <h3 class="project-name">{{project.name}}</h3>
                  <p class="project-location">Location: {{project.location}}</p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <!-- Mobile Grid -->
      <v-col cols="12" class="d-flex d-sm-none">
        <v-row >
          <v-col v-for="(project, i) in projects" :key="i" cols="12" class="px-6">
            <v-card>
              <img :src="project.image" contain width="100%"/>

              <v-card-text>
                <div class="project-details">
                  <h3 class="project-name">{{project.name}}</h3>
                  <p class="project-location">Location: {{project.location}}</p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </page>
</template>

<script>
import project1 from '../assets/images/projects/project-1.jpg'
import project2 from '../assets/images/projects/project-2.jpg'
import project3 from '../assets/images/projects/project-3.jpg'
import project4 from '../assets/images/projects/project-4.jpg'
import project5 from '../assets/images/projects/project-5.jpg'
import project6 from '../assets/images/projects/project-6.jpg'
import project7 from '../assets/images/projects/project-7.jpg'
import project8 from '../assets/images/projects/project-8.jpg'
import project9 from '../assets/images/projects/project-9.jpg'
import project10 from '../assets/images/projects/project-10.jpg'
import project11 from '../assets/images/projects/project-11.jpg'
import project12 from '../assets/images/projects/project-12.jpg'
import project13 from '../assets/images/projects/project-13.jpg'
import project14 from '../assets/images/projects/project-14.jpg'
import project15 from '../assets/images/projects/project-15.jpg'

export default {
  name: 'projects',

  data: () => ({
    projects: [
      {
        name: 'Third tank calibration',
        location: 'Port Harcourt Refinery',
        image: project1
      },
      {
        name: 'Tank mixer to be installed on a crude tank',
        location: 'Port Harcourt Refinery',
        image: project2
      },
      {
        name: 'Scaffolding for rehabilitation works',
        location: 'Port Harcourt Refinery',
        image: project3
      },
      {
        name: 'Installation of tank floating roof tube seal system',
        location: 'Port Harcourt Refinery',
        image: project4
      },
      {
        name: 'Tank rehabilitation in progress',
        location: 'Port Harcourt Refinery',
        image: project5
      },
      {
        name: 'Blasting and painting of storage tank',
        location: 'Port Harcourt Refinery',
        image: project6
      },
      {
        name: 'Installation of tank floating roof tube seal',
        location: 'Port Harcourt Refinery',
        image: project7
      },
      {
        name: 'Tank rehabilitation in progress',
        location: 'Port Harcourt Refinery',
        image: project8
      },
      {
        name: 'Installation of floating line',
        location: 'Port Harcourt Refinery',
        image: project9
      },
      {
        name: 'Installation of tank floating roof tube seal',
        location: 'Port Harcourt Refinery',
        image: project10
      },
      {
        name: 'Blasting and painting of storage tank',
        location: 'Port Harcourt Refinery',
        image: project11
      },
      {
        name: 'Installation of tank mixer /agitator',
        location: 'Port Harcourt Refinery',
        image: project12
      },
      {
        name: 'Painted associated piping and valves',
        location: 'Port Harcourt Refinery',
        image: project13
      },
      {
        name: 'Site mobilization',
        location: 'Port Harcourt Refinery',
        image: project14
      },
      {
        name: 'Scaffolding for floating roof rehabilitation',
        location: 'Port Harcourt Refinery',
        image: project15
      }
    ]
  })
}
</script>
<style scoped>
.highlight-img {
  width: 100vw;
  height: 70vh;
  background-image: url('../assets/images/projects/refinery-maintenance.jpg');
  background-attachment: fixed;
  background-position: 50% 0%;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
